import React from 'react';
import { Radio } from 'antd';

import './styles.scss';

const { Group, Button } = Radio;

const AntRadioLarge = (props) => {
  const { options, defaultValue, value, handleChange } = props;

  function onChange(e) {
    handleChange(e);
  }
  return (
    <Group value={value} onChange={onChange} defaultValue={defaultValue}>
      {options.map((data) => (
        <Button key={data.value} value={data.value} disabled={data.disabled}>
          {data.name}
        </Button>
      ))}
    </Group>
  );
};

export default AntRadioLarge;
